function sansPrefix(address) {
  if (address == null) return null;
  return address.replace(/^0x/, "").replace(/^Fx/, "");
}
function withPrefix(address) {
  if (address == null) return null;
  return "0x" + sansPrefix(address);
}
function display(address) {
  return withPrefix(address);
}

export { display, sansPrefix, withPrefix };
//# sourceMappingURL=util-address.module.js.map
